import { createFileRoute, Outlet } from "@tanstack/react-router";

// Layout-only route — index page lives in `services.index.tsx` to avoid
// emitting a duplicate canonical/hrefLang link tag on child service pages.
export const Route = createFileRoute("/services")({
  component: () => <Outlet />,
});
